import { useMutation, useQuery } from 'react-query'
import { apiUrl } from 'constants/urls'
import { InboxCount, InboxMessage } from 'shared-types'
import { useCustomFetch, usePut } from './shared'

const NOTIFICATION_TYPES = ['all', 'available', 'expired', 'read'] as const
type NotificationType = (typeof NOTIFICATION_TYPES)[number]

export const useNotifications = (notificationType: NotificationType, pageSize: number, pageNumber: number) => {
  const customFetch = useCustomFetch()

  const { data, isLoading } = useQuery<InboxMessage[]>(
    ['notifications', notificationType, pageSize, pageNumber],
    async () => {
      const response = await customFetch(
        `${apiUrl}/customer/notification/all?limit=${pageSize}&offset=${(pageNumber - 1) * pageSize}&notificationType=${notificationType}`
      )
      if (!response.ok) {
        throw new Error('Response not ok')
      }

      return await response.json()
    }
  )

  return {
    messages: data ?? [],
    isLoading,
  }
}

export const useNotificationCount = () => {
  const customFetch = useCustomFetch()

  const { data } = useQuery<InboxCount>('notifications-count', async () => {
    const response = await customFetch(`${apiUrl}/customer/notification/count`)
    if (!response.ok) {
      throw new Error('Response not ok')
    }

    return await response.json()
  })

  return data ?? { totalCount: 0, unreadCount: 0 }
}

export const useMarkAsRead = () => {
  const put = usePut()

  return useMutation(async (messageId: number) => {
    const response = await put(`${apiUrl}/customer/notification/set-read/${messageId}`)
    if (!response.ok) {
      throw new Error('Response not ok')
    }
    return await response.json()
  })
}
